<div
  data-testid="reporting-period-container"
  class="reporting-period-container"
>
  <goab-text mt="none" mb="none" tag="span">
    <span data-testid="reporting-period" class="reporting-period"
      >Reporting for the week of: {{ selectedFacilityBeds() |
      capacityReportingPeriod }}</span
    >
  </goab-text>
  <goab-text mt="none" mb="none" tag="span">
    <span data-testid="report-due" class="report-due"
      ><span class="bold-text">Report due: </span>{{ selectedFacilityBeds()! |
      capacityReportingPeriod : 'due' }}</span
    >
  </goab-text>
  <goab-text mt="none" mb="none" tag="span">
    @if(selectedFacilityBeds()?.completedOn) {
    <span data-testid="completed-on" class="completed-on"
      ><span class="bold-text">Completed on: </span>{{ selectedFacilityBeds()! |
      capacityReportingPeriod : 'completed' }}</span
    >
    } @else {
    <span data-testid="completed-on" class="completed-on"
      ><span class="bold-text">Completed on: </span>-</span
    >
    }
  </goab-text>
  <goab-text mt="none" mb="none" tag="span">
    @if(selectedFacilityBeds()?.reporter) {
    <span data-testid="reporter" class="reporter"
      ><span class="bold-text">Reporter: </span>{{
      selectedFacilityBeds()?.reporter }}</span
    >
    } @else {
    <span data-testid="reporter" class="reporter"
      ><span class="bold-text">Reporter: </span>-</span
    >
    }
  </goab-text>
  <goab-text mt="none" mb="none" tag="span">
    <span
      data-testid="facility-smoking-policy-confirmation"
      class="smoking-facility"
      ><span class="bold-text">Smoking policy confirmed: </span> {{
      selectedFacilityBeds()?.facilityHasSmokingPolicy ? 'Yes' : '-' }}&nbsp;
      @if(selectedFacilityBeds()?.facilityHasSmokingPolicy) {
      <goab-link
        mt="none"
        mb="xs"
        [attr.id]="'facility-smoking-policy-confirmation-link'"
        data-testid="facility-smoking-policy-confirmation-link"
      >
        <a [routerLink]="['/help']" fragment="smokingPolicySection"
          >Change response</a
        >
      </goab-link>
      }
    </span>
  </goab-text>
</div>
<goab-divider mt="xl" mb="m"></goab-divider>
